import { useTranslation } from 'react-i18next';

import './modalCouponStyles.css';
import closeImg from 'styles/assets/close.svg';
import { Modal } from '@mui/material';

export function ModalCoupon({ storeInfo, isOpen, onRequestClose, storeUrl }) {
  const { t } = useTranslation('app');

  if (!storeInfo) return null;

  return (
    <Modal open={isOpen} onClose={onRequestClose}>
      <div className="react-modal-content">
        <button type="button" onClick={onRequestClose} className="react-modal-close">
          <img src={closeImg} alt="Fechar modal" />
        </button>
        <div className="container-modal">
          <h3 className="title-modal-coupon">{storeInfo.description}</h3>
          {t('modalCoupon.cupom')}{' '}
          <span className="container-coupon">{storeInfo.checkoutCode}</span>
          <div className="copy-coupon-description">{t('modalCoupon.copy_code')}</div>
          <span>{storeInfo.detailsDescription}</span>
          <a className="button-visit-store" href={storeUrl} target="_blank" rel="noreferrer">
            {t('modalCoupon.visit_store')}
          </a>
        </div>
      </div>
    </Modal>
  );
}
